export default __webpack_public_path__ + "static/media/GradientLoader.05f83cc7.gif";